import { render, staticRenderFns } from "./centerDepartment.vue?vue&type=template&id=67a794eb&"
import script from "./centerDepartment.vue?vue&type=script&lang=js&"
export * from "./centerDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports